import styled from 'styled-components';
const MultipleInputPopoverBodyWrapper = styled.div.withConfig({
  displayName: "MultipleInputPopoverBodyWrapper"
})(["max-height:50vh;overflow-y:auto;"]);
export default MultipleInputPopoverBodyWrapper;